import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

interface IBody {
  width: number;
  isToggle?: boolean;
}

export const StyledText = styled.text`
  color: ${beam.font.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
`;

export const Table = styled.table`
  width: 100%;
  display: block;
  border-collapse: separate;
  border-spacing: 0;
  text-align: left;
  margin-top: 16px;
`;

export const Thead = styled.thead`
  /* UI Properties */
  display: block;
  width: 100%;
  margin-bottom: 16px;
  padding-right: 6px;
`;
export const Tbody = styled.tbody`
  overflow-y: auto;
  display: grid;
  position: relative;
  padding-left: 1px;
  padding-right: 6px;
  border-spacing: 0 0;
  //border-collapse: separate;
`;
export const Tr = styled.tr`
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 #00000029;
  z-index: auto;
  margin-bottom: 15px;
  margin-top: 1px;
  display: flex;
  align-items: center;
  width: 100%;
  overflow-x: hidden;
`;
export const Trh = styled.tr`
  z-index: 100;
  width: 100%;
  display: flex;
`;
export const Td = styled.td<IBody>`
  width: ${({ width }) => width}%;
  max-width: ${({ width }) => width}%;
  border: solid 0 transparent;
  height: 48px;
  padding: 0 16px;
  //background: #fff;
  color: #1a1b1c;
  font-size: 16px;
  font-weight: 400;
  align-items: center;
  text-align: start;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  display: flex;

  &:first-child {
    border-left-style: solid;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    position: ${({ isToggle }) => (isToggle ? 'unset' : 'relative')};
  }

  &:last-child {
    border-right-style: solid;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
  }

  :after {
    content: '';
    width: 40px;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
    right: 0;
    position: absolute;
    background: -webkit-linear-gradient(
      left,
      rgba(255, 255, 255, 0) 70%,
      #fff 95%
    );
    height: 48px;
    z-index: 4;
  }
`;
export const Label = styled.div`
  display: flex;
  align-items: center;
`;
export const LinkLabel = styled.div`
  display: flex;
  max-width: 200px;
  align-items: center;
  color: ${beam.font.link};
  cursor: pointer;
`;
export const Image = styled.img`
  width: 32px;
  height: 24px;
  border-radius: 4px;
  object-fit: cover;
  margin-right: 16px;
  &.defaultImage {
    border: none;
  }
`;
export const Icon = styled.img`
  width: 14px;
  height: 14px;
  object-fit: cover;
  margin-left: 16px;
`;
export const User = styled.div`
  display: flex;
  align-items: center;
`;

export const Th = styled.th<IBody>`
  width: ${({ width }) => width}%;
  border: solid 1px transparent;
  height: 32px;
  padding: 0 16px;
  background: #fafbfd;
  color: #758ca3;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  align-items: center;

  position: relative;
  display: flex;

  &:first-child {
    border-left-style: solid;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &:last-child {
    border-right-style: solid;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
  }
`;
export const Line = styled.div`
  height: 0;
  width: 100%;
  margin-top: 9px;
  /* borders/default-border */
  border: 1px solid #e9edf1;
`;
export const Button = styled.button`
  color: #1a1b1c;
  border: none;
  background: transparent;
  cursor: pointer;
  :disabled {
    opacity: 0.3;
    cursor: auto;
  }
`;
export const LabelQuantity = styled.div`
  margin-left: 20px;
  margin-right: 20px;
`;
export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
